import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface InlineConfirmButtonProps {
  onConfirm: () => void;
  isPending?: boolean;
  confirmLabel?: string;
  children: React.ReactNode;
  variant?: "ghost" | "outline";
  size?: "xs" | "sm" | "icon";
  "aria-label"?: string;
}

export function InlineConfirmButton({
  onConfirm,
  isPending = false,
  confirmLabel = "Eliminar",
  children,
  variant = "ghost",
  size = "sm",
  "aria-label": ariaLabel,
}: InlineConfirmButtonProps) {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <div className="flex items-center gap-1">
        <Button
          variant="destructive"
          size="xs"
          onClick={() => {
            onConfirm();
            setConfirming(false);
          }}
          disabled={isPending}
        >
          {isPending ? (
            <Loader2 className="h-3 w-3 animate-spin" />
          ) : (
            confirmLabel
          )}
        </Button>
        <Button
          variant="outline"
          size="xs"
          onClick={() => setConfirming(false)}
          disabled={isPending}
        >
          No
        </Button>
      </div>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => setConfirming(true)}
      disabled={isPending}
      aria-label={ariaLabel}
    >
      {children}
    </Button>
  );
}
